import GenericRestComponent from '../GenericRestComponent';
import {time} from '../helpers';

export default class seatmap_settings_component extends GenericRestComponent {
    constructor(uri, app, className, data) {
        super(uri, app, (className || 'seatmap_settings_component'), data);
        this.endpoint_uri = this.uri.replace(
            'seatmap_settings', 'seatmap_preference'
        );
    }

    get(forceUpdate, callback, fail) {
        const m = this.uri.match(/(\d+)\/$/);
        this.psgRange = [1, 2, 3, 4, 5, 6, 7, 8, 9];
        if (m) {
            this.passengers_count = parseInt(m[1]);
            this.endpoint_uri = this.endpoint_uri.replace(/\d+\/$/, '');
        }
        if (this.passengers_count) this.psgRange = [this.passengers_count];
        super.get(forceUpdate, () => {
            if (!this.data.data.strategies) {
                this.data.data.strategies = {};
            }
            if (typeof (callback) === 'function') {
                callback();
            }
        }, fail);
    }

    render() {
        if (this.data.data) {
            this.data.only_one_passenger = this.psgRange.length === 1;
            this.data.passengers = [];
            this.psgRange.forEach(i => {
                const str = this.app.initObject(
                    `${this.uri}strategies/${i}/`,
                    'seatmap_strategies',
                    {
                        strategies: this.app.settings.seatmap_strategies[i],
                        num: i
                    }
                );
                str.data.data = this.data.data.strategies[i];
                str.parent = this;
                str.get();
                this.data.passengers.push({
                    index: i - 1,
                    num: i,
                    seatmap_strategies: str,
                    list_strategies: str.data.strategiesList
                });
            });
        }
        super.render();
    }

    formSubmit(form, event) {
        event.preventDefault();
        const data = {
            strategies: {},
        };
        this.data.passengers.forEach((psg, _) => {
            if (psg.seatmap_strategies.data.data) {
                data.strategies[psg.num] = psg.seatmap_strategies.data.data;
            }
        });
        this.loading(true);
        this.app.ajax({
            url: this.app.settings.endpoints + this.endpoint_uri,
            method: 'PUT',
            data: {data},
            callback: data => {
                this.app.platform.sendEvent('seatmap_settings_changed');
                this.loading(false);
                this.data = Object.assign(
                    this.data,
                    typeof (this.converter) === 'function'
                        ? this.converter(data)
                        : data
                );
                this.app.dataStorage.set(this.endpoint_uri, data);
                this.updated = time();
                this.update();
                this.render();
            },
            error: (status, data) => {
                this.submitOnError(form, status, data);
            }
        });
    }

}
